module.exports = __webpack_public_path__ + "img/IMG_9928_L_BlackMatted.019662a5.jpg";